import styled from 'styled-components';

export const BrandTitle = styled.h1`
  margin: 0;
  font-size: 1.75rem;
  font-weight: 650;
  letter-spacing: -0.02em;
  color: var(--foreground);
`;

export const BrandSubtitle = styled.p`
  margin: 0.5rem 0 0;
  font-size: 0.9375rem;
  line-height: 1.45;
  letter-spacing: 0.01em;
  color: var(--muted-foreground);
`;
